var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"wrap",attrs:{"title":_vm.row[_vm.col.field]}},[_vm._v("\n  "+_vm._s(_vm.row[_vm.col.field])+"\n  "),_c('i',{staticClass:"el-icon-s-opportunity icon",on:{"click":_vm.onClick}})])}
var staticRenderFns = []

export { render, staticRenderFns }